import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { GetQuery } from './Shared';
import { toast } from 'react-toastify';

const Home = () => {
    let navigate = useNavigate();

    React.useEffect(() => {
        getData();
    }, []);
    
    const getData = async () => {
        const apiUrl = "IsDriverSystem";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            var driverSystem = result.data;
            if (driverSystem) {
                navigate("/driverjobs");
            }
        }
    }

    return (
        <div>
            <p>Welcome to the Super Safe Hire Dash Management System - Version 15.03</p>
        </div>
    );
}

export default Home;